import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import store from "Store/index";
import { AddItemToOrderingListCommand, OrderingListViewModel, RemoveItemFromOrderingListCommand, OrderingListItemViewModel } from 'Api/CoreApi';

@Component({
    template: "#ordering-list-add-remove-item-template"
})
export default class OrderingListAddRemoveItemComponent extends Vue {
    @Prop()
    public productKey: string;
    
    public loaded: boolean = true;
    
    customerAgreementConfirmDeleteElement: HTMLElement;
    confirmDelete: HTMLElement;
    
    async created() {
        
        await store.dispatch.orderingList.loadOrderingLists(false);
        //await store.dispatch.orderingList.loadMasterList();
        
        this.customerAgreementConfirmDeleteElement = document.getElementById('orderinglistCustomerAgreement_confirm_remove');
        this.confirmDelete = document.getElementById('orderinglist_confirm_delete');
    }
    
    async mounted(){
    }
    
    
    get show(){
        if(store.state.orderingList.buildList)
        return false;
        
        return this.list;
    }
    
    get isAllowed(){
        if(store.state.auth.user.roles){
            return store.state.auth.user.roles.includes('AdminAdvanced');
        }
        return false;
    }
    
    
    get canAdd(): boolean {
        //hack to trigger re-rendering of component
        var test= store.state.orderingList.detectChanges;
        if(this.item && this.item.isCustomerAgreement)
        {
            return !this.item.isAvailable;
        }
        return this.item == null;
    }
    
    
    get item() : OrderingListItemViewModel
    {
        if(this.list)
        {
            return this.list.items.find(x => x.productKey == this.productKey);
        }
        return null;
    }
    
    get list() : OrderingListViewModel{
        return store.state.orderingList.currentOrderingList;
    }
    
    async toggleProduct(event: any){
        
        if(!this.canAdd)
        {
            const item = this.list.items.find(x => x.productKey == this.productKey);
            if(item && item.isCustomerAgreement)
            {
                const msg = this.customerAgreementConfirmDeleteElement.innerHTML;
                if(!confirm(msg))
                {
                    return;
                }
            }else{
                
                const msg = this.confirmDelete.innerHTML.replace('{0}',this.productKey);
                
                if(!confirm(msg)){
                    return;
                }
            }
            
            //remove product
            await store.dispatch.orderingList.removeItemOnOrderingList(new RemoveItemFromOrderingListCommand({
                orderingListId : this.list.id,
                productKey : this.productKey
            }));
        }
        else{
            //add product
            await store.dispatch.orderingList.addItemOnOrderingList(new AddItemToOrderingListCommand({
                orderingListId : this.list.id,
                productKey : this.productKey
            }));
            
        }
    }
    
}

Vue.component('ordering-list-add-remove-item', OrderingListAddRemoveItemComponent);
